import { ChangeDetectionStrategy, Component, Inject, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { QueryParamsHandling } from '@angular/router';
import { Observable, Subject, take, takeUntil } from 'rxjs';

import { GoogleTagManagerFacade } from 'ish-core/facades/gtm.facade';
import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { ProductView } from 'ish-core/models/product-view/product-view.model';

@Component({
  selector: 'ish-product-name',
  templateUrl: './product-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductNameComponent implements OnInit, OnDestroy {
  @Input() link = true;
  @Input() alternate: string;
  @Input() queryParamsHandling: QueryParamsHandling = '';

  productName$: Observable<string>;
  productURL$: Observable<string>;
  visible$: Observable<boolean>;
  private destroy$ = new Subject<void>();
  computedQueryParamsHandling: QueryParamsHandling;
  product: ProductView;

  constructor(
    private context: ProductContextFacade,
    private gtmFacade: GoogleTagManagerFacade,
    @Optional() @Inject('PRODUCT_QUERY_PARAMS_HANDLING') private queryParamsHandlingInjector: QueryParamsHandling
  ) {}

  ngOnInit() {
    this.productName$ = this.context.select('product', 'name');
    this.productURL$ = this.context.select('productURL');
    this.visible$ = this.context.select('displayProperties', 'name');
    this.computedQueryParamsHandling = this.queryParamsHandlingInjector ?? this.queryParamsHandling;
  }

  viewItemGTMEvent() {
    this.context
      .select('product')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(product => {
        this.product = product;
        const products: ProductView[] = [this.product];
        this.gtmFacade.triggerGTMEvent('view_item', products);
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
